<div class="depth-widget-wrapper">
    <div class="depth-container margin-8-bottom">
        <div class="header-section flex-space-between">
            <div class="column column-header">
                ORDERS
            </div>

            <div class="column column-header">
                QTY
            </div>

            <div class="column column-header">
                BID
            </div>

            <div class="column column-header">
                ASK
            </div>

            <div class="column column-header">
                QTY
            </div>

            <div class="column column-header">
                ORDERS
            </div>
        </div>

        <div class="data-section">
            <div class="row flex-space-between" *ngFor="let row of depth.depth;">

                <div class="column bid-column">
                    {{ row.bidOrderCount | nullCheck }}
                </div>

                <div class="column bid-column">
                    {{ row.bidQty | nullCheck }}
                </div>

                <div class="column bid-column">
                    {{ row.bidPrice | precision:scripPrecision | nullCheck }}
                </div>

                <div class="column ask-column">
                    {{ row.askPrice | precision:scripPrecision | nullCheck }}
                </div>

                <div class="column ask-column">
                    {{ row.askQty | nullCheck }}
                </div>

                <div class="column ask-column">
                    {{ row.askOrderCount | nullCheck }}
                </div>

            </div>
        </div>
    </div>

    <div class="quote-container display-flex" *ngIf="quote">
        <div class="section">
            <div class="quote-container">
                <div class="label">
                    Open
                </div>
                <div class="value">
                    {{ quote.openPrice  | precision:scripPrecision | nullCheck }}
                </div>
            </div>

            <div class="quote-container">
                <div class="label">
                    Previous Close
                </div>
                <div class="value">
                    {{ quote.closePrice  | precision:scripPrecision | nullCheck }}
                </div>
            </div>

            <div class="quote-container">
                <div class="label">
                    Volume
                </div>
                <div class="value">
                    {{ quote.Volume | nullCheck}}
                </div>
            </div>

            <div class="quote-container">
                <div class="label">
                    Lower Circuit
                </div>
                <div class="value">
                    {{ quote.lowerCktLimit | precision:scripPrecision | nullCheck }}
                </div>
            </div>
        </div>

        <div class="section">
            <div class="quote-container">
                <div class="label">
                    High
                </div>
                <div class="value">
                    {{ quote.highPrice  | precision:scripPrecision | nullCheck }}
                </div>
            </div>

            <div class="quote-container">
                <div class="label">
                    Low
                </div>
                <div class="value">
                    {{ quote.lowPrice  | precision:scripPrecision | nullCheck }}
                </div>
            </div>

            <div class="quote-container">
                <div class="label">
                    Avg. Price
                </div>
                <div class="value">
                    {{ quote.AvgTradePrice | precision:scripPrecision | nullCheck }}
                </div>
            </div>

            <div class="quote-container">
                <div class="label">
                    Upper Circuit
                </div>
                <div class="value">
                    {{ quote.upperCktLimit | precision:scripPrecision | nullCheck }}
                </div>
            </div>
        </div>
    </div>
</div>